// extracted by mini-css-extract-plugin
module.exports = {"content":"InvalidUser_content__YFKBA","text":"InvalidUser_text__1XHcp","notice":"InvalidUser_notice__1A70c","message":"InvalidUser_message__3bNyV"};